/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserPageResVo } from './UserPageResVo';
import {
    UserPageResVoFromJSON,
    UserPageResVoFromJSONTyped,
    UserPageResVoToJSON,
    UserPageResVoToJSONTyped,
} from './UserPageResVo';

/**
 * 
 * @export
 * @interface PageDataUserPageResVo
 */
export interface PageDataUserPageResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataUserPageResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataUserPageResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataUserPageResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<UserPageResVo>}
     * @memberof PageDataUserPageResVo
     */
    records?: Array<UserPageResVo>;
}

/**
 * Check if a given object implements the PageDataUserPageResVo interface.
 */
export function instanceOfPageDataUserPageResVo(value: object): value is PageDataUserPageResVo {
    return true;
}

export function PageDataUserPageResVoFromJSON(json: any): PageDataUserPageResVo {
    return PageDataUserPageResVoFromJSONTyped(json, false);
}

export function PageDataUserPageResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataUserPageResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(UserPageResVoFromJSON)),
    };
}

export function PageDataUserPageResVoToJSON(json: any): PageDataUserPageResVo {
    return PageDataUserPageResVoToJSONTyped(json, false);
}

export function PageDataUserPageResVoToJSONTyped(value?: PageDataUserPageResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(UserPageResVoToJSON)),
    };
}

